(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireb86c"];
var parcelRegister = parcelRequire.register;
parcelRegister("54PbO", function(module, exports) {

$parcel$export(module.exports, "initCountdown", function () { return $82ec33f1fd92a019$export$35dfe98d8d261cdc; });
// Sets a countdown that counts down to the passed Date value
const $82ec33f1fd92a019$export$35dfe98d8d261cdc = (containerEl, dateTime)=>{
    // If Splide is configured to loop, we need to retrieve
    // multiple elemnts due to slide clones that are created
    const countdownEl = containerEl.getElementsByClassName("countdown__timer");
    // If no elements found - do nothing
    if (countdownEl.length <= 0) return;
    // Update each element found
    Array.from(countdownEl).forEach((el)=>{
        el.innerHTML = $82ec33f1fd92a019$var$getRemainingTime(dateTime);
        // Update the count down every 1 second
        var currentTimeInterval = setInterval(function() {
            el.innerHTML = $82ec33f1fd92a019$var$getRemainingTime(dateTime);
            // Check if countDownTime is in the past - exit interval
            if ($82ec33f1fd92a019$var$getRemainingTime(dateTime) == "EXPIRED") {
                clearInterval(currentTimeInterval);
                el.parentElement.remove();
            }
        }, 1000);
    });
};
const $82ec33f1fd92a019$var$getRemainingTime = (dateTime)=>{
    // Set the date we're counting down to
    var countDownDate = dateTime.getTime();
    // Get today's date and time
    var nowTime = new Date().getTime();
    // Find the distance between now and the countDownDate
    var diff = countDownDate - nowTime;
    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor(diff % 86400000 / 3600000);
    var minutes = Math.floor(diff % 3600000 / 60000);
    var seconds = Math.floor(diff % 60000 / 1000);
    function padWithZero(number) {
        return number < 10 ? '0' + number : '' + number;
    }
    let formattedMinutes = padWithZero(minutes);
    let formattedSeconds = padWithZero(seconds);
    // Save the remaining time as string to be output
    var timeRemaining = days + " : " + hours + " : " + formattedMinutes + " : " + formattedSeconds;
    // If the countDownDate is in the past, we return EXPIRED
    if (diff > 0) return timeRemaining;
    else return "EXPIRED";
};

});

})();
//# sourceMappingURL=initCountdown.29a1ceab.js.map
